import { FORGOT_PASSWORD_REQUEST, FORGOT_PASSWORD_END_PROCESS } from "./types"

const initialState = {
  requesting: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        requesting: true
      }

    case FORGOT_PASSWORD_END_PROCESS:
      return {
        ...state,
        requesting: false
      }

    default:
      return state
  }
}
